import { memo, useState } from "react";
import FormGroup from "@mui/material/FormGroup";
import { default as CheckboxMUI } from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

const Checkbox = memo(({ onChangeCallback, name, label, value, formik, sx }: any) => {
  const [checked, setChecked] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    formik.setFieldValue(name, isChecked);
    setChecked(isChecked);
    if (typeof onChangeCallback === "function") {
      onChangeCallback(isChecked);
    }
  };

  return (
    <FormGroup row>
      <FormControlLabel
        sx={sx}
        name={name}
        label={label}
        control={<CheckboxMUI name={name} onChange={handleChange} checked={checked} value={value} />}
      />
    </FormGroup>
  );
});

export default Checkbox;
